import React from "react";
import { routes } from "../../util/constant";
import { Route, Routes, useLocation } from "react-router-dom";
import CommonLayout from "../../ui-component/dashboard/CommonLayout";
import PageNotFound from "../pages/PageNotFound";

export default function NavRoutes() {
  let location = useLocation();

  return (
    <Routes location={location}>
      <Route
        path={routes.HOME}
        element={<CommonLayout location={location} />}
      />
      <Route
        path={routes.CAPABILITIES}
        element={<CommonLayout location={location} />}
      />
      <Route
        path={routes.CLIENT}
        element={<CommonLayout location={location} />}
      />
      <Route
        path={routes.FUNCTIONAL}
        element={<CommonLayout location={location} />}
      />
      <Route
        path={routes.SEARCH}
        element={<CommonLayout location={location} />}
      />
      {/* <Route
        path={routes.NODE}
        element={<CommonLayout location={location} />}
      /> */}
      <Route
        path={routes.VIEW_PDF}
        element={<CommonLayout location={location} />}
      />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}
